<template>
  <div class="content">
    <el-dialog top="5vh"
               :title="title"
               :visible.sync="dialogFormVisible"
               @close="dialogFormVisible = false"
               :close-on-click-modal="false"
               width="620px">
      <el-form :model="dataForm"
               label-position="right"
               ref="dataForm"
               :rules="rules"
               label-width="120px"
               size="small">
        <el-form-item label="本科院校分类："
                      prop="origin_college_category_ids">
          <el-select v-model="dataForm.origin_college_category_ids"
                     placeholder="请选择">
            <el-option v-for="item in classificationInstitutions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否跨专业："
                      prop="origin_major">
          <el-select v-model="dataForm.origin_major"
                     placeholder="请选择">
            <el-option v-for="item in transdisciplinary"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报考院校："
                      prop="apply_college">
          <el-select v-model="dataForm.apply_college"
                     filterable
                     placeholder="请选择"
                     @change="apply_collegeChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报考专业："
                      prop="apply_major">
          <el-select v-model="dataForm.apply_major"
                     @change="apply_majorChange"
                     placeholder="请选择"
                     filterable
                     style="width: 100%">
            <el-option v-for="(item, index) in apply_majorList"
                       :key="index"
                       :label="`（${item.code}）${item.name}`"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报考学院："
                      prop="apply_academy">
          <el-select v-model="dataForm.apply_academy"
                     placeholder="请选择"
                     style="width: 100%"
                     @change="apply_academyChange">
            <el-option v-for="(item, index) in academyOptions"
                       :key="index"
                       :label="item.academy_name"
                       :value="{ value: item.academy_code, label: item.academy_name,directions: item.directions, }">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="方向名称："
                      prop="direction">
          <el-select v-model="dataForm.apply_direction"
                     placeholder="请选择"
                     filterable
                     clearable
                     @change="apply_directionChange">
            <el-option v-for="(item, index) in directionOptions"
                       :key="index"
                       :label="item.direction"
                       :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
              <span>{{
                      `（${item.direction_code}）${item.direction}`
                    }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学习方式："
                      prop="apply_enrol_type">
          <el-select v-model="dataForm.apply_enrol_type"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in learnOptions"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试科目："
                      prop="apply_subject">
          <el-select v-model="dataForm.apply_subject"
                     placeholder="请选择"
                     style="width: 100%"
                     @change="subjectChange">
            <el-option v-for="(item, index) in subjectOptions"
                       :key="index"
                       :label="item"
                       :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考照顾类型："
                      prop="apply_care_type">
          <el-select v-model="dataForm.apply_care_type"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in careOptions"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐范围："
                      prop="report_view_type">
          <el-select v-model="dataForm.report_view_type"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in viewOptions"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="意向地区："
                      prop="mind_college_province_codes">
          <el-select v-model="dataForm.mind_college_province_codes"
                     style="width: 100%"
                     clearable
                     placeholder="请选择"
                     multiple>
            <!--  :multiple-limit="3" -->
            <el-option v-for="item in provinces"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="意向分类："
                      prop="mind_college_category_ids">
          <el-select v-model="dataForm.mind_college_category_ids"
                     style="width: 100%"
                     clearable
                     placeholder="请选择"
                     multiple>
            <el-option v-for="item in intentionOptions"
                       :key="item.label"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向学习方式："
                      prop="mind_enrol_type">
          <el-select v-model="dataForm.mind_enrol_type"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in mindLearnOptions"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可调剂专业："
                      prop="arr_extend_major">
          <el-select v-model="dataForm.arr_extend_major"
                     style="width: 100%"
                     placeholder="请选择"
                     value-key="value"
                     multiple
                     filterable
                     @change="$forceUpdate()">
            <el-option v-for="(item,index) in adjustableMajorOptions"
                       :key="index"
                       :label="`（${item.extend_major_code}）${item.extend_major_name}`"
                       :value="{ value: item.extend_major_code, label: item.extend_major_name }">
              <span>{{ `（${item.extend_major_code}）${item.extend_major_name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他意向专业："
                      prop="arr_apply_major_list">
          <el-select v-model="dataForm.arr_apply_major_list"
                     style="width: 100%"
                     placeholder="请选择"
                     multiple
                     filterable
                     @change="$forceUpdate()">
            <el-option v-for="(item,index) in allMajorList"
                       :key="index"
                       :label="`（${item.code}）${item.name}`"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总分："
                      prop="exam_score_total">
          <el-input v-model.trim="dataForm.exam_score_total"
                    placeholder="请输入总分"></el-input>
        </el-form-item>
        <!-- <el-form-item label="政治" prop="exam_score_politics">
          <el-input
            v-model.trim="dataForm.exam_score_politics"
            placeholder="请输入政治分数"
          ></el-input>
        </el-form-item>
        <el-form-item label="外语" prop="exam_score_language">
          <el-input
            v-model.trim="dataForm.exam_score_language"
            placeholder="请输入外语分数"
          ></el-input>
        </el-form-item>

        <el-form-item label="业务课一" prop="exam_score_business_1">
          <el-input
            v-model.trim="dataForm.exam_score_business_1"
            placeholder="请输入业务课一"
          ></el-input>
        </el-form-item>
        <el-form-item label="业务课二" prop="exam_score_business_2">
          <el-input
            v-model.trim="dataForm.exam_score_business_2"
            placeholder="请输入业务课二"
          ></el-input>
        </el-form-item>

        <el-form-item label="总分">
          <el-input
            :readonly="true"
            v-model.trim="exam_score_total"
            placeholder="总分"
          ></el-input>
        </el-form-item> -->
      </el-form>
      <div class="footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary"
                   @click="submit()"
                   plain> 确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  collegeMajorList,
  academyList,
  provinceList,
  userInfo,
  userInfoUp,
  majorList,
  majorinfo,
} from '@/api/common'
import {
  getAdjustableMajorList,
  getExtendMajorList,
  getSubjustList,
} from '@/api/adjust'
export default {
  data() {
    return {
      title: '报考信息',
      dataForm: {
        apply_college: null,
        apply_major: null,
        apply_academy: null,
        mind_college_province_codes: [''],
        mind_college_category_ids: [],
        exam_score_politics: 0,
        exam_score_language: 0,
        exam_score_business_1: 0,
        exam_score_business_2: 0,
        arr_apply_major_list: [],
      },
      dialogFormVisible: false,
      classificationInstitutions: [
        {
          label: '985',
          value: '1',
        },
        {
          label: '211',
          value: '2',
        },
        {
          label: '双一流',
          value: '3,4',
        },
        {
          label: '双非',
          value: ' ',
        },
      ],
      transdisciplinary: [
        {
          label: '是',
          value: 1,
        },
        {
          label: '否',
          value: 0,
        },
      ],

      apply_majorList: [],
      academyOptions: [],
      directionOptions: [],
      subjectOptions: [],
      allMajorList: [],
      adjustableMajorOptions: [],
      careOptions: [
        {
          label: '报考非照顾类',
          value: 0,
        },
        {
          label: '报考少干',
          value: 1,
        },
        {
          label: '报考士兵计划',
          value: 2,
        },
      ],
      viewOptions: [
        {
          label: '看所有院校',
          value: 0,
        },
        {
          label: '只看少干院校',
          value: 1,
        },
        {
          label: '只看士兵计划院校',
          value: 2,
        },
      ],
      learnOptions: [
        {
          label: '全日制',
          value: 1,
        },
        {
          label: '非全日制',
          value: 2,
        },
      ],
      mindLearnOptions: [
        {
          label: '全日制',
          value: 1,
        },
        {
          label: '非全日制',
          value: 2,
        },
        {
          label: '不限',
          value: 3,
        },
      ],
      provinces: [],

      intentionOptions: [
        // {
        //   label: "不限",
        //   value: "null",
        // },
        {
          label: '985',
          value: '1',
        },
        {
          label: '211',
          value: '2',
        },
        {
          label: '双一流',
          value: '3,4',
        },
        {
          label: '双非',
          value: '7',
        },
        {
          label: '不限',
          value: '',
        },
      ],
      uid: '',
      rules: {
        origin_college_category_ids: [
          { required: true, message: '本科院校分类不能为空', trigger: 'blur' },
        ],
        origin_major: [
          { required: true, message: '是否跨专业不能为空', trigger: 'blur' },
        ],
        apply_college: [
          { required: true, message: '报考院校不能为空', trigger: 'blur' },
        ],
        apply_major: [
          { required: true, message: '报考专业不能为空', trigger: 'blur' },
        ],
        apply_academy: [
          { required: true, message: '报考学院不能为空', trigger: 'blur' },
        ],
        apply_enrol_type: [
          { required: true, message: '学习方式不能为空', trigger: 'blur' },
        ],
        mind_college_province_codes: [
          { required: true, message: '意向地区不能为空', trigger: 'blur' },
        ],
        mind_college_category_ids: [
          { required: true, message: '意向分类不能为空', trigger: 'blur' },
        ],
        exam_score_total: [
          { required: true, message: '总分不能为空', trigger: 'blur' },
          {
            pattern: /^[1-9](\d*)$/,
            message: '请输入不为0的正整数',
            trigger: 'blur',
          },
        ],
        // exam_score_politics: [
        //   { required: true, message: "政治分数不能为空", trigger: "blur" },
        //   {
        //     pattern: /^[1-9](\d*)$/,
        //     message: "请输入不为0的正整数",
        //     trigger: "blur",
        //   },
        // ],
        // exam_score_language: [
        //   { required: true, message: "外语分数不能为空", trigger: "blur" },
        //   {
        //     pattern: /^[1-9](\d*)$/,
        //     message: "请输入不为0的正整数",
        //     trigger: "blur",
        //   },
        // ],
        // exam_score_business_1: [
        //   {
        //     pattern: /^([0]|[1-9][0-9]*)$/,
        //     message: "请输入正整数",
        //     trigger: "blur",
        //   },
        // ],
        // exam_score_business_2: [
        //   {
        //     pattern: /^([0]|[1-9][0-9]*)$/,
        //     message: "请输入正整数",
        //     trigger: "blur",
        //   },
        // ],
      },
    }
  },
  computed: {
    // exam_score_total() {
    //   return (
    //     Number(this.dataForm.exam_score_politics) +
    //     Number(this.dataForm.exam_score_language) +
    //     Number(this.dataForm.exam_score_business_1) +
    //     Number(this.dataForm.exam_score_business_2)
    //   );
    // },
  },
  created() {
    this.$store.dispatch('getAllColleges')
  },
  methods: {
    open(data) {
      this.uid = data.uid
      this.apply_majorList = []
      this.academyOptions = []
      this.getUserInfo(data.uid)
      this.fetchProvinceList()
      this.getAllMajorList()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    fetchExtendMajor(uid) {
      getExtendMajorList({ uid: uid }).then((res) => {
        if (res.arr_extend_major && res.arr_extend_major.length > 0) {
          const formattedData = res.arr_extend_major.map((item) => ({
            value: item.extend_major_code,
            label: item.extend_major_name,
          }))
          this.$set(this.dataForm, 'arr_extend_major', formattedData)
        } else {
          this.$set(this.dataForm, 'arr_extend_major', [])
        }
      })
    },
    getUserInfo(uid) {
      userInfo({
        uid: uid,
      }).then((res) => {
        this.dataForm = res
        if (!res.origin_college_category_ids) {
          this.$set(this.dataForm, 'origin_college_category_ids', ' ')
        }

        if (res.origin_major_code == '000000') {
          this.$set(this.dataForm, 'origin_major', 1)
        } else {
          this.$set(this.dataForm, 'origin_major', 0)
        }
        if (res.apply_major_name_subs && res.apply_major_code_subs) {
          let nameList = res.apply_major_name_subs.split(',,')
          let codeList = res.apply_major_code_subs.split(',,')
          this.dataForm.arr_apply_major_list = nameList.map((item, index) => {
            return {
              label: item,
              value: codeList[index],
            }
          })
        } else {
          this.dataForm.arr_apply_major_list = []
        }

        if (res.apply_college_name && res.apply_college_code) {
          this.dataForm.apply_college = {
            label: res.apply_college_name,
            value: res.apply_college_code,
          }
          this.getMajorList(res.apply_college_code)
        }

        if (res.apply_major_name && res.apply_major_code) {
          this.dataForm.apply_major = {
            label: res.apply_major_name,
            value: res.apply_major_code,
          }
          if (res.apply_college_code) {
            this.fetchMajorInfo(res.apply_college_code, res.apply_major_code)
          }
          this.fetchAdjustableMajor(res.apply_major_code)
        }
        if (res.apply_academy_name && res.apply_academy_code) {
          // this.dataForm.apply_academy = {
          //   label: res.apply_academy_name,
          //   value: res.apply_academy_code,
          // }
          setTimeout(() => {
            const academyItem = this.academyOptions.find(
              (item) => item.academy_code === res.apply_academy_code
            )
            if (academyItem) {
              this.dataForm.apply_academy = {
                label: academyItem.academy_name,
                value: academyItem.academy_code,
                directions: academyItem.directions || [],
              }
              // 加载方向列表
              this.directionOptions = academyItem.directions || []

              // 6. 方向名称回显
              if (res.apply_direction_code && res.apply_direction_name) {
                const directionItem = this.directionOptions.find(
                  (item) => item.direction_code === res.apply_direction_code
                )
                if (directionItem) {
                  this.dataForm.apply_direction = {
                    label: directionItem.direction,
                    value: directionItem.direction_code,
                  }
                  // 加载考试科目
                  this.fetchSubjustList()
                }
              }
            }
          }, 500)
        }

        if (res.apply_subject_codes && res.apply_subject_names) {
          const codes = res.apply_subject_codes.split(',')
          const names = res.apply_subject_names.split(',')
          const result = codes
            .map((code, index) => {
              return `（${code}）${names[index]}`
            })
            .join(' + ')
          this.$set(this.dataForm, 'apply_subject', result)
        } else {
          // 无数据时清空，避免脏数据
          this.$set(this.dataForm, 'apply_subject', '')
        }
        // if (res.apply_college_code) {
        //   this.getMajorList(res.apply_college_code)
        // }
        // if (res.apply_college_code && res.apply_major_code) {
        //   this.fetchAcademy(res.apply_college_code, res.apply_major_code)
        // }

        // if (res.apply_major_code) {
        //   this.fetchAdjustableMajor(res.apply_major_code)
        // }

        if (!res.apply_enrol_type) {
          this.$set(this.dataForm, 'apply_enrol_type', 1)
        }
        this.dataForm.apply_care_type = res.apply_care_type || 0
        this.dataForm.report_view_type = res.report_view_type || 0
        if (res.mind_college_province_codes) {
          let codesList = res.mind_college_province_codes.split(',')

          let codeA =
            '11,12,13,14,21,22,23,31,32,33,34,35,36,37,41,42,43,44,50,51,61'
          let codeB = '15,45,46,52,53,54,62,63,64,65'

          let codeA_flag = codeA
            .split(',')
            .every((i) => codesList.some((j) => i == j))
          let codeB_flag = codeB
            .split(',')
            .every((i) => codesList.some((j) => i == j))

          if (codeA_flag && codeB_flag) {
            let list = codesList.filter((item) =>
              [...codeA.split(','), ...codeB.split(',')].every((i) => item != i)
            )
            this.dataForm.mind_college_province_codes = [codeA, codeB, ...list]
          } else if (codeA_flag) {
            let list = codesList.filter((item) =>
              codeA.split(',').every((i) => item != i)
            )
            this.dataForm.mind_college_province_codes = [codeA, ...list]
          } else if (codeB_flag) {
            let list = codesList.filter((item) =>
              codeB.split(',').every((i) => item != i)
            )
            this.dataForm.mind_college_province_codes = [codeB, ...list]
          } else {
            this.dataForm.mind_college_province_codes = codesList
          }
          // if (res.mind_college_province_codes.split(",").length <= 3) {
          //   this.$set(
          //     this.dataForm,
          //     "mind_college_province_codes",
          //     res.mind_college_province_codes.split(",")
          //   );
          // } else {
          //   let codeA =
          //     "11,12,13,14,21,22,23,31,32,33,34,35,36,37,41,42,43,44,50,51,61";
          //   let codeB = "15,45,46,52,53,54,62,63,64,65";
          //   let codes = res.mind_college_province_codes;
          //   if (codes.includes(codeA) && codes.includes(codeB)) {
          //     this.dataForm.mind_college_province_codes = [codeA, codeB];
          //   } else if (codes.includes(codeA)) {
          //     let list = codes
          //       .split(",")
          //       .filter((item) => codeA.split(",").every((i) => item != i));
          //     this.dataForm.mind_college_province_codes = [codeA, ...list];
          //   } else {
          //     let list = codes
          //       .split(",")
          //       .filter((item) => codeB.split(",").every((i) => item != i));
          //     this.dataForm.mind_college_province_codes = [codeB, ...list];
          //   }
          // }
        } else {
          this.$set(this.dataForm, 'mind_college_province_codes', ['null'])
        }

        if (res.mind_college_category_ids) {
          this.dataForm.mind_college_category_ids =
            res.mind_college_category_ids
              .split(',')
              .map((item) => {
                // if (!item) return "null";
                if (item == 3) return '3,4'
                return item
              })
              .filter((its) => its != 4)
          // console.log("Xxx",res.mind_college_category_ids)
        } else {
          this.$set(this.dataForm, 'mind_college_category_ids', [''])
        }

        if (res.mind_enrol_type == 0) {
          console.log('1')
          if (res.apply_enrol_type) {
            this.$set(this.dataForm, 'mind_enrol_type', res.apply_enrol_type)
          } else {
            this.$set(this.dataForm, 'mind_enrol_type', 1)
          }
        } else {
          this.$set(this.dataForm, 'mind_enrol_type', res.mind_enrol_type)
        }
        // console.log("res:", this.dataForm);
      })
    },

    apply_collegeChange(e) {
      //   console.log("e:", e);
      this.dataForm.apply_college_code = e.value
      this.dataForm.apply_college_name = e.label
      this.dataForm.apply_major = null
      this.dataForm.apply_major_code = ''
      this.dataForm.apply_major_name = ''
      this.apply_majorList = []
      this.dataForm.apply_academy = null
      this.dataForm.apply_academy_code = ''
      this.dataForm.apply_academy_name = ''
      this.academyOptions = []
      this.dataForm.apply_direction = null
      this.dataForm.apply_direction_code = ''
      this.dataForm.apply_direction_name = ''
      this.directionOptions = []
      this.subjectOptions = []
      this.getMajorList(e.value)
    },

    // 专业
    getMajorList(e) {
      collegeMajorList({ college_code: e, isPaging: 0 }).then((res) => {
        this.apply_majorList = res.list
      })
    },

    // 全部专业
    getAllMajorList(e) {
      majorList({ isPaging: 0 }).then((res) => {
        this.allMajorList = []
        res.list.forEach((item) => {
          if (item.children) {
            this.recursion(item.children)
          }
        })
        // console.log('allMajorList:', this.allMajorList)
      })
    },
    recursion(node) {
      node.forEach((item) => {
        if (item.children) {
          this.recursion(item.children)
        } else {
          this.allMajorList.push(item)
        }
      })
    },

    apply_majorChange(e) {
      this.dataForm.apply_major_code = e.value
      this.dataForm.apply_major_name = e.label
      this.dataForm.apply_academy = null
      this.dataForm.apply_academy_code = ''
      this.dataForm.apply_academy_name = ''
      this.academyOptions = []
      this.dataForm.apply_direction = null
      this.dataForm.apply_direction_code = ''
      this.dataForm.apply_direction_name = ''
      this.directionOptions = []
      this.subjectOptions = []
      this.subjectResult = []
      this.fetchMajorInfo(this.dataForm.apply_college_code, e.value)
      console.log('fetchAdjustableMajor')

      this.fetchAdjustableMajor(e.value)
    },

    // 学院
    fetchAcademy(college_code, major_code) {
      academyList({
        college_code: college_code,
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.academyOptions = res.list || []
        if (this.academyOptions.length && !this.dataForm.apply_academy) {
          this.$set(this.dataForm, 'apply_academy', {
            label: this.academyOptions[0].name,
            value: this.academyOptions[0].code,
          })
        }
      })
    },
    //学院 方向
    fetchMajorInfo(college_code, major_code) {
      majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
        this.academyOptions = res.academys
        const academy = this.academyOptions.find(
          (item) => item.academy_code === this.dataForm.apply_academy_code
        )
        if (academy) {
          this.directionOptions = academy.directions
        }
      })
    },
    formatSubjectGroupsWithBrackets(data) {
      return data.map((group) => {
        return group
          .map((subject) => {
            // 政治/英语等公共课加括号
            if (['101', '201', '202', '203', '204'].includes(subject.code)) {
              return `（${subject.code}）${subject.name}`
            }
            return `${subject.code} ${subject.name}`
          })
          .join('+')
      })
    },
    fetchSubjustList() {
      getSubjustList({
        college_code: this.dataForm.apply_college_code,

        major_code: this.dataForm.apply_major_code,

        academy_code: this.dataForm.apply_academy_code,

        enrol_type: this.dataForm.apply_enrol_type,

        direction_code: this.dataForm.apply_direction_code,
      }).then((res) => {
        this.subjectOptions = this.formatSubjectGroupsWithBrackets(
          res.arr_all_subject_info
        )
      })
    },
    //可调剂意向专业
    fetchAdjustableMajor(major_code) {
      console.log('fetchAdjustableMajor')
      getAdjustableMajorList({
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.adjustableMajorOptions = res.arr_adjustable_major || []
        this.fetchExtendMajor(this.uid)
      })
    },

    apply_academyChange(e) {
      console.log('学院', e)
      this.directionOptions = e.directions
      this.dataForm.apply_academy_code = e.value
      this.dataForm.apply_academy_name = e.label
      this.$forceUpdate()
    },
    apply_directionChange(e) {
      this.dataForm.apply_direction_code = e.value
      this.dataForm.apply_direction_name = e.label
      this.fetchSubjustList()
    },
    subjectChange(e) {
      const index = this.subjectOptions.findIndex((item) => item == e)
      console.log('所选科目', index)
      this.dataForm.apply_subject_codes = this.subjectResult[index]
        .map((item) => item.code)
        .join(',')
      this.dataForm.apply_subject_names = this.subjectResult[index]
        .map((item) => item.name)
        .join(',')
    },
    fetchProvinceList() {
      provinceList().then((res) => {
        this.provinces = res.list
        this.provinces.unshift({
          name: '二区',
          code: '15,45,46,52,53,54,62,63,64,65',
        })
        this.provinces.unshift({
          name: '一区',
          code: '11,12,13,14,21,22,23,31,32,33,34,35,36,37,41,42,43,44,50,51,61',
        })
        this.provinces.unshift({
          name: '不限',
          code: 'null',
        })
      })
    },

    submit() {
      // console.log("Xxx",this.dataForm.arr_apply_major_list)
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          //   console.log(
          //     this.dataForm.mind_college_province_codes.join(),
          //     this.dataForm.mind_college_category_ids.join()
          //   );
          // if (
          //   (!this.dataForm.mind_college_province_codes.join() ||
          //     this.dataForm.mind_college_province_codes.includes("null")) &&
          //   (!this.dataForm.mind_college_category_ids.join() ||
          //     this.dataForm.mind_college_category_ids.includes("null"))
          // ) {
          //   this.$message.error("调剂意向不能同为不限(不选=不限)");
          //   return;
          // }

          let data = {
            id: this.dataForm.id,
            uid: this.dataForm.uid,
            origin_college_code: null,
            origin_college_name: null,
            origin_major_code:
              this.dataForm.origin_major == 1
                ? '000000'
                : this.dataForm.apply_major_code,
            origin_major_name: null,
            origin_college_category_ids:
              this.dataForm.origin_college_category_ids,
            // origin_major:this.dataForm.origin_major,
            apply_enrol_type: this.dataForm.apply_enrol_type,
            apply_major_code: this.dataForm.apply_major_code,
            apply_major_name: this.dataForm.apply_major_name,
            apply_academy_code: this.dataForm.apply_academy.value,
            apply_academy_name: this.dataForm.apply_academy.label,
            apply_college_code: this.dataForm.apply_college_code,
            apply_college_name: this.dataForm.apply_college_name,
            // exam_score_politics: this.dataForm.exam_score_politics,
            // exam_score_language: this.dataForm.exam_score_language,
            // exam_score_business_1: this.dataForm.exam_score_business_1,
            // exam_score_business_2: this.dataForm.exam_score_business_2,
            exam_score_total: this.dataForm.exam_score_total,
            apply_major_code_subs: this.dataForm.arr_apply_major_list
              .map((item) => item.value)
              .join(',,'),
            apply_major_name_subs: this.dataForm.arr_apply_major_list
              .map((item) => item.label)
              .join(',,'),
            mind_enrol_type: this.dataForm.mind_enrol_type,
            apply_care_type: this.dataForm.apply_care_type,
            report_view_type: this.dataForm.report_view_type,
            apply_direction_code: this.dataForm.apply_direction_code,
            apply_direction_name: this.dataForm.apply_direction_name,
            // apply_subject: this.dataForm.apply_subject,
            apply_subject_codes: this.dataForm.apply_subject_codes,
            apply_subject_names: this.dataForm.apply_subject_names,

            arr_extend_major: this.dataForm.arr_extend_major.map((item) => ({
              extend_major_code: item.value,
              extend_major_name: item.label,
            })),
          }
          if (this.dataForm.mind_college_category_ids.includes('')) {
            data.mind_college_category_ids = ''
          } else {
            data.mind_college_category_ids =
              this.dataForm.mind_college_category_ids.join()
          }
          if (this.dataForm.mind_college_province_codes.includes('null')) {
            data.mind_college_province_codes = ''
          } else {
            data.mind_college_province_codes =
              this.dataForm.mind_college_province_codes.join()
          }

          userInfoUp(data).then((res) => {
            if (!res) {
              this.$message.success('修改成功！')
              this.dialogFormVisible = false
            }
          })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: right;
  margin-top: 20px;
}
</style>